import { pathToRoot, PropertyPathWalker } from './PropertyPathWalker.js';
import { EnumType, TypeKind } from '../types.js';
import { Schema } from '../schema.js';
import { Option, OptionGroup } from '../option.js';
import { SourceUtils } from './SourceUtils.js';
import { PModel, PropertyPath } from '../engine.js';
import { ModelSystemProperties } from '../internal/ModelSystemProperties.js';

export class PropertyValueIterable {

  private index: number = 0;
  public readonly values: Array<Option | OptionGroup> | number[] | string[] | undefined;

  constructor(public schema: Schema, model: PModel, path: PropertyPath) {
    const walker = new PropertyPathWalker(path, schema, model, ModelSystemProperties.getTypeRef(model));
    const propertyValue = walker.getPropertyValue();
    // TODO: Implement this.schema.getTypeByPath();
    let propertyType = this.schema.getType(propertyValue.property.type);

    if (propertyType.kind === TypeKind.Enum) {
      this.values = (propertyType as EnumType).values;
    } else {
      let sourceUtils = new SourceUtils(schema);
      this.values = sourceUtils.getPropertySources(model, path);
    }
    //
    //   if(propertyType.kind === TypeKind.Object) {
    // 	let parent ;
    //   if(propertyValue.property.opts.needSource && ModelSystemProperties.getSource(propertyValue)) {
    // 	  // singleSource
    // 		this.values = ModelSystemProperties.getSource(propertyValue)!.getSource() as any[];
    // 	} else if((parent = propertyValue.parent)) {
    // 		let parentType = schema.getType(parent.property.type);
    // 		if(parentType.kind === TypeKind.List && parent.property.opts.needSource && ModelSystemProperties.getSource(parent)) {
    //       if (parent.property.opts.needSource === 'specific'){
    //         // listSpecificSource and property provided as 'property.nested.3'
    //         this.values = ModelSystemProperties.getSource(parent)[propertyValue.property.name].getSource(propertyValue.property.name) as any[];
    //       } else {
    //         // listCommonSourceForNested and property provided as 'property.nested'
    //         this.values = ModelSystemProperties.getSource(parent)!.getSource(propertyValue.property.name) as any[];
    //       }
    // 		} else if ((parent = parent.parent)){
    //       let parentType = schema.getType(parent.property.type);
    //       if(parentType.kind === TypeKind.List && parent.property.opts.needSource && ModelSystemProperties.getSource(parent)) {
    //         // listCommonSourceForNested and property provided as 'property.3.nested'
    //         this.values = ModelSystemProperties.getSource(parent)!.getSource(propertyValue.property.name) as any[];
    //       }
    //     }
    // 	}
    // } else if(propertyType.kind === TypeKind.List && propertyValue.property.opts.needSource && ModelSystemProperties.getSource(propertyValue)) {
    //   if (propertyValue.property.opts.needSource == 'specific'){
    //     throw new Error('For Lists with needSource == specific you have to specify concrete index e.g. property.nested.1')
    //   }
    //   // listCommonSource
    // 	this.values = ModelSystemProperties.getSource(propertyValue)!.getSource() as any[];
    // } else {
    // 	this.values = undefined;
    // }
  }

  next(): any | undefined {
    if (this.values && this.values.length > this.index) {
      let val = this.values[this.index];
      this.index++;
      return val;
    }
  }
}
